import { Box, Button, Link } from '@mui/material'
import { domain, env } from '../../../../../../../core/Env'

export const SignupForm = ({ signupRef }) => {
    const location = window.location.pathname
    
    const rHandler = (login_type) => {
        const getPath = location.split('/')
        const callbackData = {id: getPath[4], type: getPath[3]}
        const str = JSON.stringify(callbackData)
        const subcbVal = window.btoa(str)

        let ubrlink;
        if (login_type === 'registration') {
            if (env() === 'prod') {
                ubrlink = `${domain('mp').url}/subscription/checkout/rqx?tid=dG9vbF8zNjU=&callback=prod&platform=personal&subscription=c3Vic2NyaXB0aW9uXzMzMQ==&ref=unauth&auth_type=registration&entry=ubr_subtool&subcb=${subcbVal}`
            } else if(env() === 'sb') {
                ubrlink = `${domain('mp').url}/subscription/checkout/rqx?tid=dG9vbF8zMzE=&callback=sb&platform=personal&subscription=c3Vic2NyaXB0aW9uXzM5OQ==&ref=unauth&auth_type=registration&entry=ubr_subtool&subcb=${subcbVal}`
            } else if(env() === 'dev') {
                ubrlink = `${domain('mp').url}/subscription/checkout/rqx?tid=dG9vbF80OTk=&callback=dev&platform=personal&subscription=c3Vic2NyaXB0aW9uXzYyOQ==&ref=unauth&auth_type=registration&entry=ubr_subtool&subcb=${subcbVal}`
            } else {
                console.log('no valid env');
            }
        } else if (login_type === 'login'){
            if (env() === 'prod') {
                ubrlink = `${domain('pm').url}/sso/rqx?from=WEIrd1cyTnR2L2FZeFhBZDRCc3NWbnN2VUVGN2hWeWs=&callback=production&platform=personal&subcb=${subcbVal}`
            } else if(env() === 'sb') {
                ubrlink = `${domain('pm').url}/sso/rqx?from=WEIrd1cyTnR2L2FZeFhBZDRCc3NWbnN2VUVGN2hWbWc=&callback=sandbox&platform=personal&subcb=${subcbVal}`
            } else if(env() === 'dev') {
                ubrlink = `${domain('pm').url}/sso/rqx?from=WEIrd1cyTnR2L2FZeFhBZDRCc3NWbnN2VUVGN2dsT28=&callback=development&platform=personal&subcb=${subcbVal}`
            } else {
                console.log('no valid env');
            }
        }

        window.location.href = (ubrlink)
    }

    
    return (
       <Box
            ref={signupRef}
            p="16px"
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            gap="30px"
            bgcolor="#FFFFFF"
        >
            <Box fontSize="24px" fontWeight="600" textAlign="center" width="100%">
                Create an account to get full access to this {location.split('/')[3]}.
            </Box>
            <Box display="flex" alignItems="center" flexDirection="column" gap="24px">
                <Button
                    variant="contained"
                    disableElevation
                    fullWidth
                    size="large"
                    onClick={() => rHandler('registration')}
                >
                    Continue reading
                </Button>
                <Box fontSize="14px" display="flex">
                Already have an account?&nbsp;
                <Link component="button" variant="body2" onClick={() => rHandler('login')}>
                    Login
                </Link>
                </Box>
            </Box>
        </Box>

    )
}
